import * as reducers from './reducers';

export const constants = {
  NAME: 'emailReminder',
};

export default { constants, reducers };
